import AreaChart from "../../../components/templates/DashboardTeamplate/Charts/AreaChart";
import BarChart from "../../../components/templates/DashboardTeamplate/Charts/BarChart";
import ColumnChart from "../../../components/templates/DashboardTeamplate/Charts/ColumnChart";
import LineChart from "../../../components/templates/DashboardTeamplate/Charts/LineChart";
import PieChart from "../../../components/templates/DashboardTeamplate/Charts/PieChart";

export enum ChartType {
  Area = "AreaChart",
  Line = "LineChart",
  Pie = "PieChart",
  Column = "ColumnChart",
  Bar = "BarChart",
}

export const ChartOptionsMap = {
  [ChartType.Area]: { label: "Area Chart", component: AreaChart },
  [ChartType.Line]: { label: "Line Chart", component: LineChart },
  [ChartType.Pie]: { label: "Pie Chart", component: PieChart },
  [ChartType.Column]: { label: "Column Chart", component: ColumnChart },
  [ChartType.Bar]: { label: "Bar Chart", component: BarChart },
};

export interface LeadGroupCountDto {
  period: string;
  inprogress: number;
  hot: number;
  warm: number;
  interested: number;
  rejected: number;
}